import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6A2B3740-C02F-4097-9713-80C34636CA12
 * name music-note-whole-dotted
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-whole-dotted.svg
 * tags
 * - Music 
 */
export const MusicNoteWholeDottedIcon = createSvgIcon(<><path d="M10 15A2 2 0 1 1 8 17A2 2 0 0 1 10 15M10 13A4 4 0 1 0 14 17A4 4 0 0 0 10 13M16.5 17A1.5 1.5 0 1 1 15 18.5A1.5 1.5 0 0 1 16.5 17Z" /></>, 'MusicNoteWholeDottedIcon');
export default MusicNoteWholeDottedIcon